document.addEventListener('alpine:init', () => {
  Alpine.data('xFiltersAndSortby', (sectionId) => ({
    t: '',
    show: false,
    showFilterAside: true,
    loading: false,
    isDesktop: false,
    listLayout: false,
    cachedResults: [],
    searchParamsPrev: window.location.search.slice(1),
    searchParamsInitial: window.location.search.slice(1),
    init() {
      if (localStorage.getItem("list-layout") == 'list') {
        this.listLayout = true;
      }
      this._initLayout();
      this._setListeners();
    },
    _initLayout() {
      let formAside = document.getElementsByClassName('form-aside')[0];
      let formDrawer = document.getElementsByClassName('form-drawer')[0];
      if (window.innerWidth > 767) {
        this.isDesktop = true;
        if (formAside) {
          formAside.setAttribute('id','FacetFiltersForm');
          if (formDrawer) formDrawer.removeAttribute('id');
        } else {
          if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
        }
      } else {
        this.isDesktop = false;
        if (formAside) formAside.removeAttribute('id');
        if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
      }
    },
    _setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev) return;
        this._renderPage(searchParams, false);
      }
      window.addEventListener('popstate', onHistoryChange);

      installMediaQueryWatcher('(min-width: 768px)', this._initLayout);
    },
    toggleLayout(theBoolean) {
      this.listLayout = theBoolean;
      localStorage.setItem("list-layout", theBoolean ? "list" : "grid" );
      window.dispatchEvent(new Event('resize'));
    },
    removeFilter(url) {
      this._reloadFilter(url);
    },
    renderPagination() {
      var formData = {
        'attributes': {
          'collection-pagination': this.$el.value             
        }
      }; 
      fetch(Shopify.routes.root+'cart/update', {
        method:'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(formData)
      }).then(() => {
        this.cachedResults = [];
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
      }); 
    },
    onSubmit(wait = 500) {
      clearTimeout(this.t);

      const func = () => {
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
        if(this.isDesktop) document.getElementById('FormSelectFilter')?.blur();
      }
      
      this.t = setTimeout(() => {
        func();
      }, wait);
    },
    rangePrice(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      priceInput = el.querySelectorAll(".price-input"),
      pricePreview = el.querySelectorAll(".price-preview"),
      range = el.querySelector(".slider .progress");
      let priceGap = 1;

      rangeInput.forEach((input) => {
        input.addEventListener("input", (e) => {
          e.preventDefault();
          // Numbers, not toFixed() strings: `"10.00" + 1` is "10.001", which is what the
          // max-price filter used to receive when the two handles met.
          let minVal = Number(rangeInput[0].value),
            maxVal = Number(rangeInput[1].value);

          if (maxVal - minVal < priceGap) {
            // classList, not className: the element carries a dozen utility classes, so
            // `className === "range-min"` was never true and dragging the MIN handle past the
            // max moved the max instead, leaving the min box showing a stale value.
            if (e.target.classList.contains("range-min")) {
              minVal = maxVal - priceGap;
              rangeInput[0].value = minVal;
              priceInput[0].value = minVal.toFixed(2);
            } else {
              maxVal = minVal + priceGap;
              rangeInput[1].value = maxVal;
              priceInput[1].value = maxVal.toFixed(2);
            }
          } else {
            priceInput[0].value = minVal.toFixed(2);
            priceInput[1].value = maxVal.toFixed(2);
            range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
            range.style.setProperty('--right_range', 100 - (maxVal / rangeInput[1].max) * 100 + '%');
          }
          // In the visitor's display currency (x-currency-display): the slider and
          // the URL stay in AED — Shopify's filter only takes the store currency —
          // but the labels the shopper reads match the prices on the cards.
          pricePreview[0].dataset.aed = minVal;
          pricePreview[1].dataset.aed = maxVal;
          if (window.xCurrency && window.xCurrency.paintFilter) {
            window.xCurrency.paintFilter(el);
          } else {
            pricePreview[0].textContent = minVal.toFixed(2);
            pricePreview[1].textContent = maxVal.toFixed(2);
          }
        });
      });
    },
    initRange(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      range = el.querySelector(".slider .progress");
      
      let minVal = Number(rangeInput[0].value).toFixed(2),
      maxVal = Number(rangeInput[1].value).toFixed(2);;
      range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
      range.style.setProperty('--right_range',100 - (maxVal / rangeInput[1].max) * 100 + '%');
    },
    _reloadFilter(url) {
      const searchParams = url.indexOf('?') == -1 ? '' : url.slice(url.indexOf('?') + 1);
      this._renderPage(searchParams);
    },
    _createSearchParams(form) {
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    },
    _updateURLHash(searchParams) {
      // x-default-in-stock: remember, for this visit, whether the customer turned the
      // default «متوفر في المخزون» off on this collection, so it is not forced back on.
      try {
        const k = 'x_av_off:' + window.location.pathname;
        if (/(^|&)filter\.v\.availability=/.test(searchParams)) sessionStorage.removeItem(k);
        else sessionStorage.setItem(k, '1');
      } catch (e) {}
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    },
    _renderPage(searchParams, updateURLHash = true) {
      this.searchParamsPrev = searchParams;
      this.loading = true;
      
      if (this.cachedResults[searchParams]) {
        this._renderResults(this.cachedResults[searchParams]);
        return;
      }

      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error(`filter request failed: ${response.status}`);
          return response.text();
        })
        .then((responseText) => {
          const html = responseText;
          this._renderResults(html);
          this.cachedResults[searchParams] = html;   // only cache a result that rendered
          document.dispatchEvent(new CustomEvent("eurus:collection:reloaded"));
        })
        .catch(() => {
          // A failed request (or a render that threw) used to leave the spinner up for ever.
          // Load the same filtered page the ordinary way instead — the result the shopper
          // asked for, just without the in-place update.
          window.location.assign(`${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
        });

      if (updateURLHash) this._updateURLHash(searchParams);
    },
    _renderResults(html) {
      this._renderFilters(html);
      this._renderProductGridContainer(html);
      this._renderProductCount(html);
      this.loading = false;
      this._announceFilters();
    },
    // What the shopper narrowed down to — filters, sort, page — and how many
    // products it left. Read by the tracker as `filter_applied`; nothing else
    // records it (Shopify reports no event for filtering).
    _announceFilters() {
      try {
        if (Shopify.designMode || !Shopify.analytics) return;
        const params = new URLSearchParams(window.location.search);
        const filters = {};
        params.forEach((value, key) => {
          if (key.indexOf('filter.') === 0) (filters[key] = filters[key] || []).push(value);
        });
        const meta = document.getElementById('x-results-meta');
        const d = meta ? meta.dataset : {};
        Shopify.analytics.publish('filter_applied', {
          kind: d.kind || null,
          list_id: d.listId || null,
          list_title: d.listTitle || null,
          query: d.query || params.get('q') || null,
          filters,
          sort_by: params.get('sort_by') || null,
          page: Number(params.get('page') || 1),
          result_count: d.total != null && d.total !== '' ? Number(d.total) : null,
        });
      } catch (e) { /* reporting must never break filtering */ }
    },
    _renderFilters(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      let blockFiltesDrawer = '.form-drawer';
      let blockFiltesAside = '.form-aside';
      const selectBlockFiltesDrawer = document.querySelector(blockFiltesDrawer);
      const selectBlockFiltesAside = document.querySelector(blockFiltesAside);
      // There are several #active-filter-tag regions on one page (desktop and mobile), so an id
      // lookup only ever refreshed the first. Refresh each from its counterpart, in order.
      const activeTags = document.querySelectorAll('[id="active-filter-tag"]');
      const freshTags = parsedHTML.querySelectorAll('[id="active-filter-tag"]');
      activeTags.forEach((activeTag, i) => {
        if (freshTags[i]) activeTag.innerHTML = freshTags[i].innerHTML;
      });
      if (selectBlockFiltesDrawer) {
        if (this.$el.id) {  
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        selectBlockFiltesDrawer.innerHTML = parsedHTML.querySelector(blockFiltesDrawer).innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      if (selectBlockFiltesAside) {
        if (this.$el.id) {
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        selectBlockFiltesAside.innerHTML = parsedHTML.querySelector(blockFiltesAside).innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      this._renderAdvancedFilters(parsedHTML);
    },
    _renderAdvancedFilters(html) {
      const destination = document.querySelectorAll(".filter-advanced");
      const source = html.querySelectorAll('.filter-advanced');

      if (source.length > 0 && destination.length > 0) {
        destination.forEach((destination, index) => {
          destination.innerHTML = source[index].innerHTML;
        })
      }
    },
    _renderProductGridContainer(html) {
      document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    },
    _renderProductCount(html) {
      const productCountEl = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
      if (productCountEl) {
        const count = productCountEl.innerHTML;
        const container = document.getElementById('ProductCount_header');
        const containerDrawer = document.getElementById('ProductCountDrawer');
        if (container) container.innerHTML = count;
        if (containerDrawer) containerDrawer.innerHTML = count;
        if (container) container.classList.remove('loading');
      }
    },
    _renderAdditionalElements(html) {
      const container = document.getElementById('ProductPerPage');
      if (container) container.innerHTML = html.getElementById('ProductPerPage').innerHTML;
    },
    _filterFocus() {
      Alpine.store('xFocusElement').trapFocus('ProductFilter','CloseFilter');
    },
    _filterRemoveFocus() {
      const activeElement = document.getElementById('btn-filter');
      Alpine.store('xFocusElement').removeTrapFocus(activeElement);
    },
    setFilterHeaderHeight() {
      document.documentElement.style.setProperty('--height-sticky-filter',document.getElementById("FacetsWrapperDesktop").offsetHeight + "px");
    },
    setPositionOptionFilter(el) {
      elRect = el.getBoundingClientRect();
      const elPopup = el.getElementsByClassName('popup-above')[0];
      let spacingRight = window.xViewport.innerWidth - elRect.left;
      let checkSpacing = spacingRight - el.innerWidth;
      if (checkSpacing >= 0) {
        elPopup.style.left = '0px';
      } else {
        elPopup.style.left = checkSpacing+ 'px';
      }
    },
    getPopupPosition(el) {
      this.$nextTick(() => {
        const elPopup = el.getElementsByClassName('popup-above')[0];
        if (elPopup) {
          const popupRect = elPopup.getBoundingClientRect();
          if( popupRect.right > window.xViewport.innerWidth){
            elPopup.style.right = 0;
          }
        }
      });
    }
  }));
});